/**
 * Enum for XR tracking state.
 */
export enum XRTrackingState {
  /** Not tracking */
  NotTracking,
  /** Tracking */
  Tracking,
  /** Lost track */
  TrackingLost
}
